enum CustomerSourceOfAddress {
  PUBLIC_REGISTER = 'PUBLIC_REGISTER',
  CUSTOMER = 'CUSTOMER',
}

export default CustomerSourceOfAddress;
